var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wordcloud",style:(_vm.areaSize)})
}
var staticRenderFns = []

export { render, staticRenderFns }